import React from 'react'
import "../../View/ReferAndEarnPage/ReferAndEarn.css"
import ReferAndEarnBanner from './ReferAndEarnBanner'
import MaximiseYourEarnings from './MaximiseYourEarnings'
import HereHowReferralWorks from './HereHowReferralWorks'
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions'
import ReferAndEarnTermsConditions from './ReferAndEarnTermsConditions'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const ReferAndEarnHome = () => {
  const seoMetaData = {
    title: "NeooSearch Refer and Earn Program – Share & Earn Rewards!",
    description: "Join the NeooSearch Refer and Earn Program and start earning rewards by sharing NeooSearch with your friends and family. Discover how our referral program works and maximize your earnings today!",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "NeooSearch Refer and Earn Program",
    url: process.env.REACT_APP_APPLICATION_URL + "/refer-and-earn",
    keywords: "NeooSearch, refer and earn, referral program, share and earn, rewards program, earn rewards, refer friends, maximize earnings",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/refer-and-earn"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <ReferAndEarnBanner />
      <MaximiseYourEarnings />
      <HereHowReferralWorks />
      <FrequentlyAskedQuestions />
      <ReferAndEarnTermsConditions />
    </>
  )
}

export default ReferAndEarnHome